import React from "react";
import { motion } from "framer-motion";

export default function AboutMom3ntum({ config }) {
  const defaultParagraphs = null; // rendered inline below when config?.paragraphs not provided

  return (
    <section className="py-20 px-4" style={{ background: "#1A1A1A" }} dir="rtl">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          {/* Text — right side in RTL */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="flex-1 text-right"
          >
            <p className="text-xs font-black uppercase tracking-widest mb-3" style={{ color: "#C8F135" }}>מי אנחנו</p>
            {config?.heading != null ? (
              <h2
                className="font-bold text-white mb-5 leading-tight"
                style={{ fontSize: "clamp(1.6rem, 2.8vw, 40px)" }}
              >
                {config.heading}
              </h2>
            ) : (
              <h2
                className="font-bold text-white mb-5 leading-tight"
                style={{ fontSize: "clamp(1.6rem, 2.8vw, 40px)" }}
              >
                הכירו את Mom3ntum:<br />מעבירים את המשחק לידיים שלכם!
              </h2>
            )}

            {config?.paragraphs != null ? (
              config.paragraphs.map((text, i) => (
                <p key={i} className="text-sm md:text-base leading-relaxed mb-1" style={{ color: "rgba(255,255,255,0.78)", maxWidth: "496px" }}>
                  {text}
                </p>
              ))
            ) : (
              <>
                <p className="text-sm md:text-base leading-relaxed mb-1" style={{ color: "rgba(255,255,255,0.78)", maxWidth: "496px" }}>
                  {`התרגלתם לראות "Sold Out" תוך דקות ולשלם אלפי שקלים לספסרים?`}
                </p>
                <p className="text-sm md:text-base leading-relaxed mb-1" style={{ color: "#c8f135", maxWidth: "496px" }}>
                  אז דיי!
                </p>
                <p className="text-sm md:text-base leading-relaxed mb-4" style={{ color: "rgba(255,255,255,0.78)", maxWidth: "496px" }}>
                  Mom3ntum היא פלטפורמה וקהילת מעריצים גלובלית שנועדה להבטיח שלעולם לא תישארו בחוץ. אנחנו מאפשרים לקהילה שלנו להשיג כרטיסים לאירועי הענק – פסטיבלים, פורמולה 1, מונדיאל והופעות בינלאומיות – במחירי העלות הרשמיים.
                </p>
                <p className="text-sm md:text-base leading-relaxed mb-4" style={{ color: "rgba(255,255,255,0.78)", maxWidth: "496px" }}>
                  איך אנחנו עושים את זה? הכוח שלנו נמצא במספרים. אנחנו דואגים שתקבלו עדכונים בזמן אמת על פתיחת קופות כדי שתמיד תהיו צעד אחד לפני כולם, ומשריינים מראש כרטיסים לאירועים המבוקשים בעולם. ככל שהקהילה גדלה, כך כוח הקנייה שלנו מתעצם, מה שמאפשר לנו להציע לחברים כרטיסים נחשקים במחיר הוגן, ללא עמלות וללא ספסרים.
                </p>
                <p className="text-base font-semibold text-white mb-2" style={{ maxWidth: "496px" }}>
                  איך זה עובד עכשיו עם המונדיאל?
                </p>
                <p className="text-sm md:text-base leading-relaxed" style={{ color: "rgba(255,255,255,0.78)", maxWidth: "496px" }}>
                  בעוד שהכרטיסים הרשמיים כבר שולשו מהעלות המקורית שלהם ברחבי העולם, לחברי קהילת Mom3ntum עדיין נשארה הקצאה.
                </p>
              </>
            )}
          </motion.div>

          {/* Image — left side in RTL */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex-1 w-full max-w-md"
          >
            <div className="rounded-[30px] overflow-hidden" style={{ aspectRatio: "4/3" }}>
              <img
                src={config?.image ?? "/images/giveaway/community_photo.png"}
                alt="Mom3ntum קהילה"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}